/* ═══════════════════════════════════════════════════════════════
   FABLE FIXES JS — cart drawer live discount amount. Additive.
   Applies/removes codes via /cart/update.js and shows the $ saved.
   Isolated add-on: if it fails, the core cart still works.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // Disable the theme's soft (sessionStorage) discount pre-fill so it
  // does not fight the real cart-level discount state below.
  try { sessionStorage.removeItem('tbh_discount_code'); } catch (e) {}

  function money(cents) { return '$' + (Math.abs(cents) / 100).toFixed(2); }

  function activeDiscount(cart) {
    if (!cart || !cart.discount_codes || !cart.total_discount) return null;
    var dc = cart.discount_codes.filter(function (d) { return d.applicable; })[0];
    if (!dc) return null;
    return { code: dc.code, amount: cart.total_discount };
  }

  function reRender() {
    if (typeof window.__openCartDrawer === 'function') window.__openCartDrawer();
  }

  function setDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); });
  }

  function applyCode(code, note, btn) {
    setDiscount(code).then(function (cart) {
      var dc = (cart.discount_codes || []).filter(function (d) {
        return d.code.toLowerCase() === code.toLowerCase();
      })[0];
      if (dc && dc.applicable && cart.total_discount) {
        reRender();
      } else {
        setDiscount('').then(function () {
          if (note) note.textContent = 'That code is not valid for the items in your cart.';
          if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
        });
      }
    }).catch(function () {
      if (note) note.textContent = 'Something went wrong. Please try again.';
      if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
    });
  }

  function removeCode() {
    setDiscount('').then(function () { reRender(); }).catch(function () {});
  }

  function injectSavings(body, disc) {
    var footer = body.querySelector('.cart-drawer__footer');
    if (!footer || footer.querySelector('.fable-savings-row')) return;
    var subtotal = footer.querySelector('.cart-drawer__subtotal');
    var row = document.createElement('div');
    row.className = 'fable-savings-row';
    row.innerHTML = '<span>Discount (' + disc.code + ')</span><strong>-' + money(disc.amount) + '</strong>';
    if (subtotal) footer.insertBefore(row, subtotal); else footer.appendChild(row);
  }

  function enhance(body) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var disc = activeDiscount(cart);
      var form = body.querySelector('[data-discount-form]');
      var applied = body.querySelector('[data-discount-applied]');
      var codeDisp = body.querySelector('[data-discount-code-display]');
      var statusEl = body.querySelector('.cart-discount-status');
      var applyBtn = body.querySelector('[data-discount-apply]');
      var removeBtn = body.querySelector('[data-discount-remove]');
      var input = body.querySelector('[data-discount-input]');
      var note = body.querySelector('[data-discount-note]');
      var toggle = body.querySelector('.cart-discount-toggle');

      if (applyBtn) {
        var nb = applyBtn.cloneNode(true);
        applyBtn.parentNode.replaceChild(nb, applyBtn);
        nb.addEventListener('click', function () {
          var code = ((input && input.value) || '').trim();
          if (!code) { if (note) note.textContent = 'Enter a code first.'; return; }
          if (note) note.textContent = '';
          nb.disabled = true; nb.textContent = 'Applying...';
          applyCode(code, note, nb);
        });
      }
      if (removeBtn) {
        var rb = removeBtn.cloneNode(true);
        removeBtn.parentNode.replaceChild(rb, removeBtn);
        rb.addEventListener('click', function () { removeCode(); });
      }

      if (disc) {
        if (form) form.setAttribute('hidden', '');
        if (applied) applied.removeAttribute('hidden');
        if (codeDisp) codeDisp.textContent = disc.code;
        if (statusEl) statusEl.textContent = 'You saved ' + money(disc.amount);
        if (toggle) toggle.setAttribute('open', '');
        injectSavings(body, disc);
      } else {
        if (applied) applied.setAttribute('hidden', '');
        if (form) form.removeAttribute('hidden');
      }
    }).catch(function () {});
  }

  function boot() {
    var body = document.querySelector('[data-cart-body]');
    if (!body) return;
    var mo = new MutationObserver(function () { enhance(body); });
    mo.observe(body, { childList: true });
    enhance(body);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();